import { b as __awaiter, c as __generator } from '../tslib.es6-c6da0ae6.js';
import { useEffect } from 'react';
import { i } from '../detectIncognito.esm-e89d4263.js';
import { u as useRegistrationFormContext } from '../RegistrationFormContext-20b6a976.js';

var useIsIncognito = function useIsIncognito() {
  var setIsIncognito = useRegistrationFormContext().setIsIncognito;
  useEffect(function () {
    var detect = function detect() {
      return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4, i()];
            case 1:
              result = _a.sent();
              setIsIncognito(result === null || result === void 0 ? void 0 : result.isPrivate);
              return [2];
          }
        });
      });
    };
    detect();
  }, [setIsIncognito]);
};

export { useIsIncognito as default };
//# sourceMappingURL=index.js.map
